import {FC} from 'react'
import {Navigate, useLocation} from 'react-router-dom'
import {
 isProtectedPath,
 storeRedirectUri,
} from 'helpers/authRedirect'

const UnauthenticatedRouteGuard: FC = () => {
 const location = useLocation()
 const {pathname, search} = location

 if (isProtectedPath(pathname)) {
  storeRedirectUri(`${pathname}${search}`)
 }

 return <Navigate to='/login' replace />
}

export default UnauthenticatedRouteGuard
